import { Link } from "react-router-dom";
import { Column, Grid, Row } from "carbon-components-react";

import { Item } from "./Item";

export const FoodVendorRow = ({
  loading = false,
  puerpera = {},
  foodVendor = {},
  foodVendorName = "",
  center = {},
}) => {
  const { id = "", name = "" } = puerpera;
  var { name: foodvendor_name = "" } = foodVendor;
  if (!!foodVendorName) {
    foodvendor_name = foodVendorName;
  }

  const center_name = center.name ? `(${center.name})` : "";
  return (
    <Grid>
      <Row>
        <Column>
          <Item labelText="產婦姓名" showTop={false} loading={loading}>
            {id ? <Link to={`/puerpera/${id}/info`}>{name}</Link> : name}
          </Item>
        </Column>
        <Column>
          <Item labelText="目前膳食供應商" showTop={false} loading={loading}>
            {foodvendor_name ? `${center_name} ${foodvendor_name}` : ""}
          </Item>
        </Column>
      </Row>
    </Grid>
  );
};
